import clsx from 'clsx'
import React from 'react'
import PropTypes from 'prop-types'
import FlexColumn from '../../FlexColumn'
import FlexRow from '../../FlexRow'
import MarkupPreview from '../../../atoms/MarkupPreview'
import { useFormattingContext } from '../../../organisms/FormattingProvider/FormattingContext'
import DenaliActionMenu from '../../../organisms/DenaliActionPipeline/triggers/DenaliActionMenu'

export default function NoteV1 ({ activity, length, onClick, actions, className, style }) {
  const { formatter } = useFormattingContext()
  const _style = {
    backgroundColor: '#fbfcbd',
    border: '1px solid #ffe09c',
    ...(style || {})
  }

  return (
    <FlexColumn className={clsx(className, 'gap-sm clickable radius-md p-md shadow-sm')} style={_style} onClick={onClick}>
      <FlexRow>
        <FlexRow className='justify-between flex-1'>
          <div>{activity.subject}</div>
          <div>{formatter(activity.createdDate, 'date')}</div>
        </FlexRow>
        {actions?.length ? (
          <DenaliActionMenu size='16px' actions={actions} subject={activity} />
        ) : null}
      </FlexRow>
      <div style={{ textOverflow: 'ellipsis', overflow: 'auto' }}>
        <MarkupPreview type='html' length={length} value={activity.content} />
      </div>
    </FlexColumn>
  )
}

NoteV1.propTypes = {
  activity: PropTypes.shape({
    subject: PropTypes.string,
    content: PropTypes.string,
    createdDate: PropTypes.string
  }).isRequired,
  actions: PropTypes.array,
  className: PropTypes.string,
  length: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.object
}
